angular.module('manageSysManageEmailTempConfigModule', [])
	.controller('manageSysManageEmailTempConfigCtrl', ['$scope', function($scope){
		console.log("这里是邮件模板设置")
	}]);